import { format } from 'date-fns';
// @ts-ignore
import { to_jira as mdToJira } from 'jira2md';
import Turndown from 'turndown';

const DATE_FORMAT = 'MMM d, yyyy';
const DATETIME_FORMAT = `${DATE_FORMAT} h:mm a`;

export const formatSize = (bytes: number, decimals = 2) => {
  if (bytes === 0) return '0 Bytes';
  const k = 1024;
  const dm = decimals < 0 ? 0 : decimals;
  const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
};

export const formatDate = (
  value: string | Date | null | undefined,
  dateOnly: boolean = false
) => {
  if (!value) return '';
  return format(
    typeof value === 'string' ? new Date(value) : value,
    dateOnly ? DATE_FORMAT : DATETIME_FORMAT
  );
};

// from https://stackoverflow.com/a/2901298/7013346
export function formatWithCommas(value: number | string): string {
  return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}

export function formatWithDecimals(
  value: number | string | null | undefined,
  digits: number = 2
): string {
  let parsedValue: number = parseFloat(`${value}`);
  parsedValue = isFinite(parsedValue) ? parsedValue : 0;
  return parsedValue.toFixed(digits);
}

export function formatCurrency(
  value: number | string | null | undefined,
  currency: string = '$'
): string {
  return currency + formatWithCommas(formatWithDecimals(value));
}

export function htmlToMd(html: string): string {
  return new Turndown().turndown(html);
}

export function htmlToJira(html: string): string {
  return mdToJira(htmlToMd(html));
}

export function stripHtml(value: string) {
  return value.replace(/(&nbsp;|<([^>]+)>)|\n/gi, ' ');
}

export function pluralize(n: number, singular: string, plural: string) {
  return n === 1 ? singular : plural;
}
